import { Dispatch, SetStateAction } from 'react';

export enum Security {
  'Admin' = 1,
  'User' = 2,
}
export interface User {
  id: number;
  description: string;
  loginId: string;
  security?: Security;
  webAccess?: number;
  type?: string;
}

export interface AuthContextType {
  authToken: string | null;
  setAuthToken: Dispatch<SetStateAction<string | null>>;
  refreshToken: string | null;
  setRefreshToken: Dispatch<SetStateAction<string | null>>;
}
